/**
 * <TutorPickerModal> — « Quel tuteur ? », l'étape qui précède le composeur (template).
 *
 * Elle ne s'ouvre QUE s'il y a plusieurs tuteurs : avec un seul, l'écran va droit au composeur
 * existant (`<SendTutorMessageModal>`), qui reste le seul endroit où l'on écrit un message.
 * Ce template ne compose pas le message — il désigne le destinataire. Le composeur prend sa
 * place sous le même en-tête, 2ᵉ étape, et son retour ramène ici, le choix d'avant coché.
 */
import React from "react"

import { Button } from "../../atoms/Buttons/Button"
import { TutorPickerStep } from "../../organisms/TutorPickerStep"
import { type UIParentTutorChoice } from "../../../ports/primary/ui/types"
import { ParentFlowModal } from "../ParentFlowModal"

export type TutorPickerModalProps = {
    visible: boolean
    onClose: () => void
    childFirstname: string
    tutors: UIParentTutorChoice[]
    selectedId?: UIParentTutorChoice["tutor"]["id"]
    onSelect: (choice: UIParentTutorChoice) => void
    testID?: string
}

export function TutorPickerModal(props: TutorPickerModalProps) {
    const { visible, onClose, childFirstname, tutors, selectedId, onSelect, testID } = props

    return (
        <ParentFlowModal
            visible={visible}
            onClose={onClose}
            title="Écrire à un tuteur"
            stepTitle="Quel tuteur ?"
            step={1}
            totalSteps={2}
            context={`${childFirstname} a ${tutors.length} tuteurs.`}
            footer={<Button label="Annuler" variant="outline" onPress={onClose} />}
            testID={testID}
        >
            <TutorPickerStep tutors={tutors} selectedId={selectedId} onSelect={onSelect} />
        </ParentFlowModal>
    )
}
